/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_appsync_graphqlEndpoint": "https://j6lgz5n63vcwzezhid2b5kn7fy.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-p63ef6akungznhu6zdzyf4huxe",
    "aws_cloud_logic_custom": [
        {
            "name": "presignedUrlApi",
            "endpoint": "https://05w17lh4ta.execute-api.ap-northeast-1.amazonaws.com/production",
            "region": "ap-northeast-1"
        }
    ],
    "aws_cognito_identity_pool_id": "ap-northeast-1:7fc20933-12f2-48b1-a47e-42e2ba9da5cd",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_UV45vOS7H",
    "aws_user_pools_web_client_id": "518p00qpsj5fathskkbt9b1o2m",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "emarfv3pathjson143729-production",
    "aws_user_files_s3_bucket_region": "ap-northeast-1"
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js